import { render, staticRenderFns } from "./ServiceCloud.vue?vue&type=template&id=53eb4036&scoped=true&"
import script from "./ServiceCloud.vue?vue&type=script&lang=js&"
export * from "./ServiceCloud.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCloud.vue?vue&type=style&index=0&id=53eb4036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb4036",
  null
  
)

component.options.__file = "ServiceCloud.vue"
export default component.exports